import React, { useState, useEffect, useContext } from 'react'
import {Button, TextField, IconButton, InputAdornment, makeStyles, useMediaQuery} from '@material-ui/core'
import { AuthContext } from "../../App.js"
import md5 from 'blueimp-md5'
import './index.css'
import {ReactComponent as ShowPwdImg} from '../../assets/show-password.svg'
import {ReactComponent as HidePwdImg} from '../../assets/hide-password.svg'
import COLORS from '../../colors.js'
import { isMobile } from 'react-device-detect'
 

const useStyles = makeStyles((theme) => ({
	form:{
		position:'relative',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
	},
	usrnameInput:{
	 
	},
	passwdInput:{
		marginTop: '1rem',
		marginBottom: '1rem'
  	},
	input:{

	},
	btn:{
		display:'flex',
	    justifyContent: 'center',
        background: COLORS.blue,
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 'bold',
		"&:hover": {
			backgroundColor: COLORS.blue
	  	} 
	}
}));

const Form = ({validateCreds, attempts, username}) => {
	const matches = useMediaQuery('(min-width:600px)')
    const {signIn, setUsername} = useContext(AuthContext)
    const [ usrname, setUsrname] = useState('')
    const [ passwd, setPasswd ] = useState('')
    const [ keypad, setKeypad ] = useState(false)
    const [ isRevealPwd, setIsRevealPwd ] = useState(false)
	const [ isDisabled, setIsDisabled ] = useState(true)
 
	const classes = useStyles()

	const [ width, setWidth ] = useState(window.innerWidth);
	const [ height, setHeight ] = useState(window.innerHeight);

    useEffect(()=>{
            function hideKeypad(){
                  setWidth(window.innerWidth)
                  setHeight(window.innerHeight)	 	 
            }
            window.addEventListener('resize', hideKeypad, false)
            return () => window.removeEventListener('resize', hideKeypad, false)
    },[])

	const generateHash = async (password) => {
			return await md5(password)
	}

	useEffect(()=>{
		if(usrname!==''&&passwd!==''){
				setIsDisabled(false)
		}else{
				setIsDisabled(true)
		}
	},[usrname,passwd])

	const handleUsername = (e) => {
		if(e.target.value.length<31){
				setUsrname(e.target.value)
		}
	}

	const handlePasswd = (e) => {
		if(e.target.value.length<31){
				setPasswd(e.target.value)
		}
	}

    const handleSubmit = (e) => {
  			e.preventDefault()
			setUsername(usrname)
	  		generateHash(passwd).then(hashPasswd=>{
				  	signIn({usrname,hashPasswd})
			}).catch(error=>{
					console.log("Unable to generate hash code for given password", error)
			})
  	}

	const handleKeyDown = (event) => {
		if(event.key==='Enter'&&!isDisabled){
				handleSubmit(event)
		}
  	}

  return (
    <div>
	  	<div style={{
			  		position: 'relative',
					top:height>500?'14vh':'7vh',
			  		dispaly:'flex', 
					justifyContent:'center',
					alignItems: 'center', 
					width:'100%'
					}}>
	  				{(validateCreds===1&&attempts!==2)?
					  <div style={{color:'red', textAlign:'center', marginLeft:'1rem',marginRight:'1rem'}} 
						>Unjeli ste pogrešnu lozinku, preostali broj pokušaja: <span style={{color:COLORS.blue, fontWeight:'600'}}>{3-attempts}</span>.</div>:null}
					{(validateCreds===1&&attempts===2)?
					  <div style={{color:'red', textAlign:'center', marginLeft:'1rem',marginRight:'1rem'}} 
						>Ako još jednom pogrešno upišeš lozinku tvoj račun će biti zaključan!</div>:null}
					{(validateCreds===3)?
					  <div style={{color:'red', textAlign:'center', marginLeft:'1rem',marginRight:'1rem'}} 
						>Maximalni broj pokušaja prijave je 3, tvoj je {attempts}.</div>:null}
					{(validateCreds===-1)?
					  <div style={{color:'red', textAlign:'center', marginLeft:'1rem',marginRight:'1rem'}} 
						>Korisničko ime <span style={{color:COLORS.blue, fontWeight:'600'}}>{username}</span> ne postoji! </div>:null}
					{(validateCreds===-3)?
					  <div style={{color:'red', textAlign:'center', marginLeft:'1rem',marginRight:'1rem'}} 
						>Tvoje token je istekao, moraš se ponovno autorizirati! </div>:null}
		</div>
	  	<form className={classes.form} style={{top:height>500?'18vh':'11vh'}} onSubmit={handleSubmit}>
	  			<TextField  variant="outlined"
				  			label={usrname===''?"Upiši korisničko ime":"Korisničko ime"}
                            onFocus={()=>setKeypad(true)}
                            onBlur={()=>setKeypad(false)}
							style={{width:!isMobile?'25rem':'90%'}} 
                            className={classes.usrnameInput}
							type="text"
                            value={usrname}
                            onChange = {(e)=>handleUsername(e)}
							InputLabelProps={{
								style: {
									color: COLORS.blue,
									fontWeight: '600'
									}
							}}	  
                />
				<TextField  variant="outlined"
				  			label={passwd===''?"Upiši lozinku":"Lozinka"}
                            onFocus={()=>setKeypad(true)}
                            onBlur={()=>setKeypad(false)}
							style={{width:!isMobile?'25rem':'90%'}} 
                            className={classes.passwdInput}
							type={!isRevealPwd?"password":"txt"}
                            InputProps = {{	className: classes.input,
                                            endAdornment: (
                                                            <InputAdornment position="start">
                                                            	<IconButton onClick={()=>setIsRevealPwd(prevState => !prevState)}>
																	{!isRevealPwd?
                                                                    <HidePwdImg style={{width:'2rem', height:'2rem', marginRight:'-1.2rem'}}/>:
																	<ShowPwdImg style={{width:'2rem', height:'2rem', marginRight:'-1.2rem'}}/>}
                                                            	</IconButton>
                                                            </InputAdornment>
                                                                          )
                                        }}
                            value={passwd}
                            onChange = {(e)=>handlePasswd(e)}
							onKeyDown={(e)=>{handleKeyDown(e)}}
							InputLabelProps={{
								style: {
									color: COLORS.blue,
									fontWeight: '600'
									}
							}}	    
                />
  				<Button size="large"
				  		variant="contained"
				  		className={classes.btn}
				  		disabled={isDisabled} 
				  		style={{width:!isMobile?'25rem':'90%'}} 
						type="submit"
				>PRIJAVA</Button>
	  	</form>
	   
    </div>
  )
}

export default Form
